module.exports = __webpack_public_path__ + "img/PROBARLO.6c085468.png";